import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { GoalInputModalPageRoutingModule } from './goal-input-modal-routing.module';

import { GoalInputModalPage } from './goal-input-modal.page';
import { Keyboard } from '@ionic-native/keyboard/ngx';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    GoalInputModalPageRoutingModule,
  ],
  declarations: [GoalInputModalPage]
})
export class GoalInputModalPageModule {}
